import { Attributes, ComponentType, ElementType } from 'react';

import Typography, { TypographyProps } from '@mui/material/Typography';

import { withProps } from '../component';

export const makeTypography = <C extends ElementType = 'p'>(
  defaultProps: TypographyProps<C, { component?: C }>,
  BaseComponent?: ComponentType<TypographyProps<C, { component?: C }>>
): ComponentType<
  Attributes &
    Omit<TypographyProps<C, { component?: C }>, keyof typeof defaultProps> &
    Partial<typeof defaultProps>
> => withProps(BaseComponent || Typography, defaultProps);
